import { UseFormReturn } from 'react-hook-form';

import { Grid } from 'components/layout';
import { NormalizedLoad } from 'types/Load';
import { Maybe } from 'types/UtilityTypes';

import { LoadBuildingTextInput } from './Customer';

interface RatesFormProps {
  formMethods: UseFormReturn<NormalizedLoad>;
  load: NormalizedLoad;
}

export function RatesForm({ formMethods: _formMethods, load }: RatesFormProps) {
  const getLabel = (base: string, unit?: Maybe<string>) =>
    unit ? `${base} (${unit})` : base;

  return (
    <Grid cols='1' gap='md' className='w-full mx-0'>
      <div className='space-y-1 text-md text-neutral-800 font-semibold mb-1'>
        Customer
      </div>
      <Grid cols='2' gap='sm' className='mx-0 w-full col-span-2'>
        <LoadBuildingTextInput
          name='rateData.customerLineHaulCharge.val'
          label={getLabel(
            'Line Haul',
            load.rateData?.customerLineHaulCharge?.unit
          )}
          inputType='number'
          options={{ valueAsNumber: true }}
          required={false}
          readOnly={true}
        />
        <LoadBuildingTextInput
          name='rateData.customerTotalCharge.val'
          label={getLabel('Total', load.rateData?.customerTotalCharge?.unit)}
          inputType='number'
          options={{ valueAsNumber: true }}
          required={false}
          readOnly={true}
        />
      </Grid>

      <div className='space-y-1 text-md text-neutral-800 font-semibold mb-1'>
        Carrier
      </div>
      <Grid cols='2' gap='sm' className='mx-0 w-full col-span-2'>
        <LoadBuildingTextInput
          name='rateData.carrierLineHaulCharge.val'
          label={getLabel(
            'Line Haul',
            load.rateData?.carrierLineHaulCharge?.unit
          )}
          inputType='number'
          options={{ valueAsNumber: true }}
          required={false}
          readOnly={true}
        />
        <LoadBuildingTextInput
          name='rateData.carrierTotalCost.val'
          label={getLabel('Total', load.rateData?.carrierTotalCost?.unit)}
          inputType='number'
          options={{ valueAsNumber: true }}
          required={false}
          readOnly={true}
        />
      </Grid>

      <div className='space-y-1 text-md text-neutral-800 font-semibold mb-1'>
        Fuel
      </div>

      <Grid cols='2' gap='sm' className='mx-0 w-full col-span-2'>
        <LoadBuildingTextInput
          name='rateData.fscPerMile'
          label={getLabel('FSC/Mile', 'USD')}
          inputType='number'
          options={{ valueAsNumber: true }}
          required={false}
          readOnly={true}
        />
        <LoadBuildingTextInput
          name='rateData.fscFlatRate'
          label={getLabel('FSC', 'USD')}
          inputType='number'
          options={{ valueAsNumber: true }}
          required={false}
          readOnly={true}
        />
      </Grid>
    </Grid>
  );
}

export default RatesForm;
